var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 261,
    viewBox: "0 0 260 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 254,
    height: 254,
    rx: 127,
    fill: "white",
    stroke: "#F7D7D0",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.677 127.713C131.456 127.713 131.308 127.713 131.087 127.713C130.718 127.64 130.202 127.64 129.759 127.713C108.372 127.053 92.2207 110.333 92.2207 89.7265C92.2207 68.7532 109.404 51.6665 130.497 51.6665C151.589 51.6665 168.773 68.7532 168.773 89.7265C168.699 110.333 152.474 127.053 131.898 127.713C131.824 127.713 131.751 127.713 131.677 127.713ZM130.497 62.6665C115.526 62.6665 103.283 74.8398 103.283 89.7265C103.283 104.393 114.788 116.2 129.464 116.713C129.833 116.64 130.866 116.64 131.824 116.713C146.279 116.053 157.637 104.247 157.711 89.7265C157.711 74.8398 145.468 62.6665 130.497 62.6665Z",
    fill: "#D83612"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.751 207.591C117.296 207.591 102.767 203.924 91.7784 196.591C81.5271 189.844 75.9221 180.604 75.9221 170.558C75.9221 160.511 81.5271 151.198 91.7784 144.378C113.903 129.784 149.746 129.784 171.723 144.378C181.901 151.124 187.58 160.364 187.58 170.411C187.58 180.458 181.975 189.771 171.723 196.591C160.661 203.924 146.206 207.591 131.751 207.591ZM97.8996 153.618C90.8196 158.311 86.9846 164.324 86.9846 170.631C86.9846 176.864 90.8934 182.878 97.8996 187.498C116.263 199.744 147.238 199.744 165.602 187.498C172.682 182.804 176.517 176.791 176.517 170.484C176.517 164.251 172.608 158.238 165.602 153.618C147.238 141.444 116.263 141.444 97.8996 153.618Z",
    fill: "#D83612"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePhoto);
export default __webpack_public_path__ + "static/media/profilePhoto.9270813c97922911d46a4cc543680e33.svg";
export { ForwardRef as ReactComponent };